<template>
  <div class="main"
       :class="[introducerInfo.nickname ? 'main-info' : '']">
    <!--介绍人信息-->
    <div v-if="introducerInfo.nickname"
         class="introducer__box clearfix">
      <div class="introducer__avatar">
        <img :src="introducerInfo.headimgurl"
             alt="">
      </div>
      <div class="introducer__info">
        <p class="introducer__name">{{introducerInfo.nickname}}</p>
        <p class="slogan">“用了生意专家，开店更轻松”
          <img class="introducer__icon"
               src="http://static.i200.cn/assets/images/FpjtHauut6tr4cw8ynUcWkRcQNIg.png"
               alt="">
        </p>
      </div>
    </div>
    <!--form表单-->
    <div class="form__wrapper">
      <div class="form__box">
        <div class="form__title">领取您的开店资料</div>
        <div class="form__content">
          <div class="form__item weui-flex"
               style="justify-content: space-between">
            <input class="form__input"
                   ref="J_shopName"
                   v-model="storeName"
                   style="width: 60%"
                   type="text"
                   placeholder="店铺名称" />
            <div class="select__wrapper">
              <select class="form__select"
                      v-model="industryName">
                <option value="零售">零售</option>
                <option value="批发">批发</option>
                <option value="服务">服务</option>
                <option value="餐饮">餐饮</option>
                <option value="其它">其它</option>
              </select>
            </div>
          </div>
          <div class="form__item">
            <input class="form__input"
                   ref="J_shopOwner"
                   v-model.trim="realName"
                   type="text"
                   placeholder="店主姓名" />
          </div>
          <div class="form__item">
            <input class="form__input"
                   type="number"
                   ref="J_phone"
                   v-model.trim="phone"
                   placeholder="手机号码" />
          </div>
          <div class="form__item">
            <input class="form__input"
                   ref="J_pwd"
                   v-model.trim="pwd"
                   type="password"
                   placeholder="请输入6-12位数字或字母组合密码" />
          </div>
          <div class="form__item">
            <div class="l-captcha"
                 data-width="100%"
                 data-callback="getResponse"
                 data-site-key="f1dfbc3b01b14a5d635c025bdf3cb55d"></div>
          </div>
          <div class="form__item weui-flex"
               style="justify-content: space-between">
            <input type="text"
                   ref="J_code"
                   v-model="code"
                   class="form__input"
                   placeholder="验证码"
                   style="width:50%" />
            <div class="form__input weui-btn_loading"
                 :class="{'weui-btn_loading': sendLoading}"
                 @click="handlerSendCode"
                 style="text-align: center;box-sizing:border-box;display: inline-block;width: 50%;background: rgb(255, 236, 97);">
              {{content}}
              <i v-if="sendLoading"
                 class="weui-loading"></i>
            </div>
          </div>
          <div class="form__item form__item--last">
            <div class="form__button"
                 @click="handlerRegister">立即获得开店资料</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SystemUser from '../../model/register-yaoqing/index'
import debounce from 'lodash.debounce'
import Cookies from 'js-cookie'

export default {
  name: 'RegisterInvite',
  data () {
    return {
      systemUser: new SystemUser(),
      appId: 'wx8de3b9a5bbf2ccdf',
      redirecUrl: null,
      dialogVisible: false,
      content: '获取验证码',
      totalTime: 60,
      canClick: true,
      validationId: null,
      sendLoading: false,
      storeName: null,
      recommend: null,
      pwd: null,
      realName: null, // 店主名称
      industryName: '零售', // 行业名称
      phone: null,
      openId: null, // 微信OpenId
      checkSign: null, // 螺丝帽返回的ID
      introducerInfo: {
        headimgurl: null,
        nickname: null
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.redirecUrl = `http://${window.location.host}/#${to.fullPath}`
      let openId = Cookies.get('openId')
      let timeStr = Cookies.get('redirect')
      if (vm.isWebChat) { // 是微信环境
        if (!openId && !timeStr) {
          Cookies.set('redirect', 1)
          vm.redirectWX()
        } else {
          vm.openId = openId
        }
      }
    })
  },
  created () {
    const self = this
    this.dynamicLoadJs('//captcha.luosimao.com/static/dist/api.js')
    window.getResponse = (resp) => {
      var els = document.getElementsByName('luotest_response')
      if (els.length === 1 && els[0].value === resp) {
        self.checkSign = resp
        window.sing = resp
        self.$nextTick(_ => {
          self.dialogVisible = true
        })
      } else {
        // eslint-disable-next-line
        LUOCAPTCHA && LUOCAPTCHA.reset();
      }
    }
  },
  mounted () {
    let code = this.$route.params.code
    if (code) {
      this.recommend = code
      this.handleGetIntroducerInfo()
    }
  },
  methods: {
    async handleGetIntroducerInfo () {
      if (this.recommend) {
        let result = await this.systemUser.getIntroducerInfo(this.recommend)
        this.introducerInfo = result
      }
    },
    handleRegister () {
      if (this._checkParams()) {
        // this.dialogVisible = true
        // this.handlerSendCode()
      }
    },
    // 发送验证码
    handlerSendCode: debounce(async function () {
      if (this._checkPhone()) {
        if (!this.canClick) return   // 改动的是这两行代码
        this.canClick = false
        // 发送验证码 loading open
        this.sendLoading = true
        try {
          let result = await this.systemUser.getSMSCode(this.phone, this.checkSign)
          if (result.ValidationId) {
            // eslint-disable-next-line
            LUOCAPTCHA && LUOCAPTCHA.reset();
            this.checkSign = null
            this.sendLoading = false
            // 结束Loading end
            this.$wejs.toast('验证码已发送', 3000)
            this.$refs.J_code.focus()
            this.validationId = result.ValidationId
            this.content = this.totalTime + 's后重新发送'
            let clock = window.setInterval(() => {
              this.totalTime--
              this.content = this.totalTime + 's后重新发送'
              if (this.totalTime < 0) {
                window.clearInterval(clock)
                this.content = '重新发送'
                this.totalTime = 60
                this.canClick = true   // 这里重新开启
              }
            }, 1000)
          } else {
            // eslint-disable-next-line
            LUOCAPTCHA && LUOCAPTCHA.reset();
            this.checkSign = null
            this.$wejs.alert(`验证失败`)
          }
        } catch (error) {
          this.$wejs.alert(`请求出错${error}`)
        }
      }
    }, 300),
    // 注册用户
    handlerRegister: debounce(function () {
      if (this._checkParams()) {
        this.$refs.J_code.blur()
        let loadingInstance = this.$wejs.loading('注册中')
        let params = {
          pin: this.code,
          phoneNumber: this.phone,
          validationId: this.validationId,
          password: this.pwd,
          code: this.recommend,
          industryName: this.industryName,
          openId: this.openId,
          storeName: this.storeName,
          realName: this.realName,
          checkSign: this.checkSign,
          nickname: Cookies.get('nickname') || null,
          headimgurl: Cookies.get('headimgurl') || null
        }
        this.systemUser.register(params).then(data => {
          loadingInstance.hide()
          if (data.Successful) {
            this.$wejs.alert(`注册成功`, () => {
              this.$router.push({ path: '/register-result' })
            })
          } else {
            // eslint-disable-next-line
            LUOCAPTCHA && LUOCAPTCHA.reset();
            this.checkSign = null
            this.$wejs.alert(`${data.FailReason}`)
          }
        })
      }
    }, 300),
    /**
     * 检测参数是否合法
     * @private
     * @return {boolean} 检测结果
     */
    _checkParams () {
      // 验证参数
      if (!this.storeName) {
        this.$wejs.alert('请输入店铺名称', () => {
          this.$refs.J_shopName.focus()
        })
        return false
      }
      if (!this.phone) {
        this.$wejs.alert('请输入手机号码', () => {
          this.$refs.J_phone.focus()
        })
        return false
      } else if (!(/^((1[3-8][0-9])+\d{8})$/.test(this.phone))) {
        this.$wejs.alert('请输入正确的手机号码', () => {
          this.$refs.J_phone.select()
        })
        return false
      } else if (!this.pwd) {
        this.$wejs.alert('请输入密码', () => {
          this.$refs.J_pwd.focus()
        })
        return false
      } else if (!(/^[a-z0-9]{6,12}$/.test(this.pwd))) {
        this.$wejs.alert('请输入6-12位数字或字母密码', () => {
          this.$refs.J_pwd.select()
        })
        return false
      } else if (!this.validationId) {
        this.$wejs.alert('请先获取验证码', () => {
          this.$refs.J_code.focus()
        })
        return false
      } else if (!this.code) {
        this.$wejs.alert('请输入验证码', () => {
          this.$refs.J_code.focus()
        })
        return false
      } else if (this.code.length !== 6) {
        this.$wejs.alert('请合法的验证码', () => {
          this.$refs.J_code.select()
        })
        return false
      } else if (!this.checkSign) {
        this.$wejs.alert('请先进行验证', () => {
        })
        return false
      } else {
        return true
      }
    },
    /**
     * 检测手机号是否合法，服务于发送验证码
     * @return {boolean}
     * @private
     */
    _checkPhone () {
      if (!this.phone) {
        this.$wejs.alert('请输入手机号码', () => {
          this.$refs.J_phone.focus()
        })
        return false
      } else if (!(/^((1[3-8][0-9])+\d{8})$/.test(this.phone))) {
        this.$wejs.alert('请输入正确的手机号码', () => {
          this.$refs.J_phone.select()
        })
        return false
      } else if (!this.checkSign) {
        this.$wejs.alert('请先进行验证', () => {
        })
        return false
      } else {
        return true
      }
    },
    // ios 兼容，input失去焦点后界面上移不恢复的问题
    resetScroll () {
      setTimeout(() => {
        let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
      }, 100)
    },
    dynamicLoadJs (url, callback) {
      var head = document.getElementsByTagName('head')[0]
      var script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = url
      if (typeof callback === 'function') {
        script.onload = script.onreadystatechange = function () {
          if (
            !this.readyState ||
            this.readyState === 'loaded' ||
            this.readyState === 'complete'
          ) {
            callback()
            script.onload = script.onreadystatechange = null
          }
        }
      }
      head.appendChild(script)
    },
    // 重定向授权
    redirectWX () {
      let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + this.appId +
        '&redirect_uri=' + encodeURIComponent(this.redirecUrl) +
        '&response_type=code&scope=snsapi_userinfo&state=#wechat_redirect'
      window.location.replace(url)
    }
  },
  computed: {
    // 是否是微信浏览器
    isWebChat () {
      return /micromessenger/.test(navigator.userAgent.toLowerCase())
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/base/_mixin';
.main {
  overflow: auto;
  width: 100%;
  background: url('../../assets/images/yaoqing/new-bg.jpeg') no-repeat;
  background-size: cover;
}
.main-info {
  background-image: url('../../assets/images/yaoqing/new-bg.png');
  .form__wrapper {
    margin-top: px2rem(809px);
  }
}

.introducer {
  &__box {
    box-sizing: border-box;
    padding: px2rem(17px) px2rem(30px);
    margin: px2rem(21px) auto 0 auto;
    width: px2rem(675px);
    min-height: px2rem(132px);
    border-radius: px2rem(24px);
    background: rgba(255, 255, 255, 0.2);
    /*animation-delay: .5s;*/
    /*animation: listAni 1s ease both;*/
  }
  &__avatar {
    float: left;
    width: px2rem(95px);
    height: px2rem(95px);
    img {
      width: 100%;
      border-radius: 50%;
    }
  }
  &__info {
    float: left;
    margin-left: px2rem(57px);
  }
  &__name {
    font-weight: bold;
    font-size: px2rem(29px);
    color: rgba(255, 231, 168, 1);
    text-shadow: 0px 2px 3px rgba(65, 65, 65, 0.29);
  }
  &__icon {
    vertical-align: text-top;
    display: inline-block;
    width: px2rem(38px);
    height: px2rem(36px);
    margin-left: px2rem(26px);
    background: url('../../assets/images/yaoqing/slogan.png') no-repeat;
  }
}
.slogan {
  font-size: px2rem(29px);
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
}
.form {
  &__wrapper {
    overflow: hidden;
    margin: px2rem(685px) auto px2rem(50px) auto;
    width: px2rem(670px);
    padding: 0 0 px2rem(17px) 0;
    background: rgba(60, 54, 226, 1);
    box-shadow: 0px 10px 30px 0px rgba(5, 7, 112, 0.8);
    border-radius: px2rem(20px);
  }

  &__box {
    box-sizing: border-box;
    overflow: hidden;
    margin: px2rem(18px) auto 0 auto;
    width: px2rem(637px);
    padding: 0 px2rem(60px);
    background: rgba(255, 254, 255, 1);
    border-radius: px2rem(14px);
  }

  &__title {
    margin: px2rem(29px) auto;
    text-align: center;
    font-size: px2rem(32px);
    font-weight: bold;
    color: rgba(57, 25, 22, 1);
    &::before {
      margin-right: px2rem(17px);
      display: inline-block;
      content: '';
      width: px2rem(33px);
      height: px2rem(29px);
      background: url('../../assets/images/yaoqing/title-left.png');
      background-size: cover;
    }
    &::after {
      margin-left: px2rem(17px);
      display: inline-block;
      content: '';
      width: px2rem(33px);
      height: px2rem(29px);
      background: url('../../assets/images/yaoqing/title-right.png');
      background-size: cover;
    }
  }

  &__item {
    margin-bottom: px2rem(18px);
    &--last {
      margin-top: px2rem(50px);
    }
  }

  &__input {
    padding: 0 px2rem(10px);
    font-size: px2rem(30px);
    box-sizing: border-box;
    border: none;
    outline: 0;
    width: 100%;
    height: px2rem(86px);
    line-height: px2rem(86px);
    background: #faf9fa;
    border-radius: px2rem(8px);
    &::placeholder {
      color: #cccccc;
    }
  }

  &__select {
    border-radius: px2rem(8px);
    background: #fbe334;
    border: none;
    height: px2rem(86px);
    width: 100%;
    padding-left: px2rem(15px);
    //清除select的边框样式
    border: none;
    //清除select聚焦时候的边框颜色
    outline: none;
    //隐藏select的下拉图标
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  &__button {
    width: px2rem(516px);
    height: px2rem(100px);
    line-height: px2rem(100px);
    color: #391916;
    font-size: px2rem(34px);
    text-align: center;
    background: url('../../assets/images/yaoqing/button__bg.png');
    background-size: 100%;
  }
}
.select__wrapper {
  position: relative;
  display: inline-block;
  width: 35%;
  &::after {
    content: ' ';
    display: inline-block;
    height: 8px;
    width: 8px;
    border-width: 0 2px 2px 0;
    border-color: #391916;
    border-style: solid;
    transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
    position: absolute;
    top: 50%;
    margin-top: -8px;
    right: px2rem(20px);
  }
}
.tip {
  margin-bottom: px2rem(30px);
  font-size: px2rem(30px);
  color: #666;
}
.dialog__button {
  width: 100%;
  padding: px2rem(6px) 0;
  text-align: center;
  color: #391916;
  font-size: px2rem(36px);
  background: #fbe334;
}
@keyframes listAni {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// new.vue?a4fb7950